module.exports = __webpack_public_path__ + "dfe5e130345072e22902907a1f6d1b11.svg";